import { render, staticRenderFns } from "./PriceTableListTable.vue?vue&type=template&id=2505aee7&scoped=true&lang=html"
import script from "./PriceTableListTable.vue?vue&type=script&lang=js"
export * from "./PriceTableListTable.vue?vue&type=script&lang=js"
import style0 from "./PriceTableListTable.vue?vue&type=style&index=0&id=2505aee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505aee7",
  null
  
)

export default component.exports